import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import moment from 'moment';

import HttpAPICall from '../../../../services/HttpAPICall';
import Loader from '../../../../components/ui/Loader/Loader';
import AnimatedMap from './AnimatedMap';

const TripSessionDetail = (props) => {

    const [imei, setImei] = useState('');
    const [tripData, setTripData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [selectedTrip, setSelectedTrip] = useState(null);

    const mapRef = useRef(null);

    const access_token = useSelector(state => state.auth.access_token);

    useEffect(() => {
        if (props?.formData?.imeis && props.formData.imeis.length > 0) {
            const firstImei = props.formData.imeis[0];
            setImei(firstImei);
            fetchTripData(firstImei);
            return;
        }

        if (props?.formData?.imei_no) {
            setImei(props.formData.imei_no);
            fetchTripData(props.formData.imei_no);
            return;
        }

        if (props?.formData?.imei) {
            setImei(props.formData.imei);
            fetchTripData(props.formData.imei);
            return;
        }

    }, [props?.formData]);

    const getDateRange = () => {
        const now = new Date();
        const twelveHoursAgo = new Date(now.getTime() - 12 * 60 * 60 * 1000);

        const start = props?.formData?.date_range_start ||
            props?.formData?.startDate ||
            props?.formData?.start_date ||
            twelveHoursAgo;

        const end = props?.formData?.date_range_end ||
            props?.formData?.endDate ||
            props?.formData?.end_date ||
            now;

        return { start, end };
    };

    const fetchTripData = (selectedImei) => {
        if (!selectedImei) {
            return;
        }

        setLoading(true);
        setTripData(null);
        setSelectedTrip(null);

        const { start, end } = getDateRange();

        const requestBody = {
            imeIs: [selectedImei.trim()],
            startDate: new Date(start).toISOString(),
            endDate: new Date(end).toISOString()
        };

        HttpAPICall.withAthorization(
            'POST',
            'https://api6.tappetbox.in/api/Report/trip-session?closeOpenAtEnd=false',
            access_token,
            {},
            requestBody,
            (resp) => {
                setTripData(resp.data);
            },
            (error) => {
                toast.error('Failed to fetch trip device data', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setTripData([]);
            }
        ).finally(() => {
            setLoading(false);
        });
    };

    const handleViewMap = (trip, tripIndex) => {
        setSelectedTrip({
            ...trip,
            tripIndex
        });
        
        // Open map using ref
        setTimeout(() => {
            if (mapRef.current) {
                mapRef.current.openMap({
                    imei: trip.imei || imei,
                    startDate: trip.actualStartTimestamp || trip.startTimestamp,
                    endDate: trip.actualStopTimestamp || trip.stopTimestamp,
                    data: trip.data
                });
            }
        }, 100);
    };

    const handleCloseMap = () => {
        setSelectedTrip(null);
    };

    const renderTripData = () => {
        if (!tripData) return null;

        if (Array.isArray(tripData) && tripData.length === 0) {
            return (
                <div className="text-center py-5">
                    <h6>No trip data available.</h6>
                </div>
            );
        }

        const trips = Array.isArray(tripData) ? tripData : [tripData];

        return (
            <div className="row mb-4">
                <div className="col-12">
                    <div className="tab_content_wrapper mb-3">
                        <h6 className="mb-0">Trip Details</h6>
                    </div>
                    <div style={{ width: '100%', overflowX: 'auto' }}>
                        <table className="table table-bordered table-hover">
                            <thead className="table-light">
                                <tr className="text-center">
                                    <th style={{width:"10%"}} className="text-center">Trips</th>
                                    <th style={{width:"20%"}}>Start</th>
                                    <th style={{width:"20%"}}>End</th>
                                    <th style={{width:"20%"}} className="text-center">Duration</th>
                                    <th style={{width:"20%"}} className="text-center">View</th>
                                </tr>
                            </thead>
                            <tbody>
                                {trips.map((trip, tripIndex) => (
                                    <tr className="text-center" key={tripIndex}>
                                        <td className="text-center">Trip {tripIndex + 1}</td>
                                        <td>
                                            {trip?.actualStartTimestamp || trip?.startTimestamp
                                                ? moment(trip?.actualStartTimestamp || trip?.startTimestamp)
                                                    .format('DD-MMM-YYYY HH:mm:ss')
                                                : 'N/A'}
                                        </td>
                                        <td>
                                            {trip?.actualStopTimestamp || trip?.stopTimestamp
                                                ? moment(trip?.actualStopTimestamp || trip?.stopTimestamp)
                                                    .format('DD-MMM-YYYY HH:mm:ss')
                                                : 'N/A'}
                                        </td>
                                        <td className="text-center">{trip?.totalDuration || 'N/A'}</td>
                                        <td className="text-primary cursor_pointer" onClick={() => handleViewMap(trip, tripIndex)}>
                                            View Movable Map
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Helmet>
                <title>Trip Data</title>
            </Helmet>

            <div className="container-fluid">
                <div className="page_containt row pl2">
                    <div className="pageTbl col-12 pl4">
                        <div className="bg-white">
                            {loading && <Loader />}
                            {!loading && renderTripData()}
                            <AnimatedMap 
                                ref={mapRef}
                                onClose={handleCloseMap}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TripSessionDetail;